import React from "react"
import PropTypes from "prop-types"

export const CarouselContext = React.createContext({})

const CarouselController = ({ autoScroll, children, totalSlides }) => {
  const [activeIndex, setActiveIndex] = React.useState(0)

  // useEffect(()=>{
  //   if(autoScroll){
  //     setInterval(  changeIndex(),1000)
  //   }
  // },[])

  //  const changeIndex = ()=>{
  //        let newIndex = (activeIndex+1)%totalSlides;
  //         setActiveIndex(newIndex)
  //         console.log("newIndex",newIndex)
  //  }

  const state = React.useMemo(() => {
    return {
      autoScroll,
      activeIndex,
      setActiveIndex,
      totalSlides,
    }
  }, [activeIndex, totalSlides])

  return (
    <CarouselContext.Provider value={state}>
      {children}
    </CarouselContext.Provider>
  )
}

CarouselController.propTypes = {
  children: PropTypes.node.isRequired,
  totalSlides: PropTypes.number.isRequired,
}

export default CarouselController
